// @flow @format
import {compose} from 'redux';
import {connect} from 'react-redux';
import Breadcrumb from '../components/Breadcrumb';
import withFileNodeCache from '../routes/Explorer/hoc/withFileNodeCache';

import type {State} from '../reducers';

const mapStateToProps = ({selection, entities}: State) => ({
	userId: selection.userId,
	machineId: selection.machineId,
	fileNode: entities.files.entities[selection.fileNodeId],
});

const enhance = compose(connect(mapStateToProps), withFileNodeCache);

export default enhance(Breadcrumb);



// WEBPACK FOOTER //
// ./src/containers/BreadcrumbContainer.js